import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

import { Store } from '@ngrx/store';

import { selectUser } from '../../../../../store/app.selectors';
import { SnackBarService } from '../../../../../core/services/snackbar.service';
import { IUserProfile } from '../../../../../modules/user/interfaces/IUserProfile';
import { ChannelRoles, ChannelType, IChannelCreationDTO } from '../../../interfaces/IChannel';
import { IMessageableEntity } from '../../../interfaces/IMessageableEntity';
import { MessagingApiService } from '../../../services/messaging-api/messaging-api.service';
import { selectChannel, setNewChannel, toggleSidebar } from '../../../store/chat.actions';
import { AppStateWithChat } from '../../../store/chat.reducer';

@Component({
  selector: 'ngx-new-group-chat',
  templateUrl: './new-group-chat.component.html',
  styleUrls: ['./new-group-chat.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NewGroupChatComponent {
  private fb = inject(FormBuilder);
  private store = inject(Store<AppStateWithChat>);
  private dialogRef = inject(MatDialogRef<NewGroupChatComponent>);
  private dataService = inject(MessagingApiService);
  private snackBarService = inject(SnackBarService);

  user = toSignal(this.store.select(selectUser), { initialValue: null as IUserProfile | null });
  usersSelected: IMessageableEntity[] = [];
  isLoading = signal(false);
  newChatForm: FormGroup = this.fb.group({
    displayName: [null, [Validators.required]],
  });

  close(): void {
    this.dialogRef.close();
  }

  createChannel(): void {
    const user = this.user();
    if (!user) {
      return;
    }
    this.isLoading.set(true);
    this.store.dispatch(toggleSidebar({ active: false }));
    const channel: IChannelCreationDTO = {
      displayName: this.newChatForm.value.displayName as string,
      type: ChannelType.GROUP,
      isPrivate: true,
      role: ChannelRoles.ADMIN,
    };
    this.dataService
      .createChannel(channel, [...this.usersSelected.map((e) => e.uid), user.subjectMessageableEntity.uid])
      .subscribe({
        next: (newChannel) => {
          this.store.dispatch(setNewChannel({ channel: newChannel }));
          this.store.dispatch(selectChannel({ channel: newChannel }));
          this.close();
        },
        error: () => {
          this.isLoading.set(false);
          this.snackBarService.showErrorSnackBar();
        },
      });
  }
}
